import { render, staticRenderFns } from "./Pagespeed.vue?vue&type=template&id=1024428c&scoped=true"
import script from "./Pagespeed.vue?vue&type=script&lang=js"
export * from "./Pagespeed.vue?vue&type=script&lang=js"
import style0 from "./Pagespeed.vue?vue&type=style&index=0&id=1024428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024428c",
  null
  
)

export default component.exports